import { api } from './client.js';

/**
 * @typedef {Object} User
 * @property {number} id
 * @property {number|null} tenantId
 * @property {'creator'|'curator'|'admin'|'rop'|'mop'} role
 * @property {number|null} parentRopId
 * @property {string} username
 * @property {string|null} fullName
 * @property {boolean} mustChangePassword
 * @property {string|null} pdnAcceptedAt
 */

/**
 * @typedef {Object} TenantPublic
 * @property {number} id
 * @property {string} name
 */

export const authApi = {
    /** @returns {Promise<{user: User, realUser: User|null, tenant: TenantPublic|null}>} */
    login: (username, password) =>
        api.post('/api/auth/login', { username, password }),

    logout: () => api.post('/api/auth/logout'),

    /**
     * При активном View-as возвращает {user: <effective>, realUser: <creator>}.
     * Иначе realUser = null. tenant — публичные поля tenant'а эффективного юзера
     * (или null если юзер — creator без tenant'а).
     * @returns {Promise<{user: User, realUser: User|null, tenant: TenantPublic|null}>}
     */
    me: (signal) => api.get('/api/auth/me', { signal }),

    /**
     * При must_change_password=true currentPassword можно не передавать.
     * Иначе он обязателен (валидация на бэке).
     */
    changePassword: (currentPassword, newPassword) =>
        api.post('/api/auth/change-password', {
            ...(currentPassword !== undefined ? { currentPassword } : {}),
            newPassword,
        }),

    /** Подтвердить согласие с обработкой персональных данных (152-ФЗ). */
    acceptPdn: () => api.post('/api/auth/accept-pdn'),

    /**
     * View-as: Создатель «проваливается» в учётку другого юзера (TZ §5.11).
     * Все последующие API-запросы будут от лица userId, банер на фронте
     * показывает реального юзера (Создателя) для возврата.
     * @returns {Promise<{user: User, realUser: User, tenant: TenantPublic|null}>}
     */
    enterActingAs: (userId) =>
        api.post(`/api/auth/acting-as/${encodeURIComponent(userId)}`),

    /**
     * Выйти из режима View-as. Возвращает к реальному юзеру.
     * @returns {Promise<{user: User, realUser: null, tenant: TenantPublic|null}>}
     */
    exitActingAs: () => api.delete('/api/auth/acting-as'),
};
